import {getPreference, currentUserMeetsUserLevel} from '@netx/core-user/utils';
import {
	AttributeHistoryPref,
	ATTRIBUTE_HISTROY_MINIMUM_LEVEL,
} from './constants';

export const attributeHistoryEnabled = () =>
	getPreference(AttributeHistoryPref.ENABLED, true);

export const canViewAttributeHistory = () =>
	currentUserMeetsUserLevel(ATTRIBUTE_HISTROY_MINIMUM_LEVEL);
